import { createReducer } from './create';

function getInitialURLValue(key, transformer, defaultValue) {
    const url = new URL(document.location);

    if (!url.searchParams.has(key)) {
        return defaultValue;
    }

    return transformer(url.searchParams.get(key));
}

function ensureLocked(key, value) {
    if (window.application.archive.filter.locked[key]) {
        return window.application.archive.filter.locked[key];
    }

    return value;
}

const initialState = {
    state: 'idle',
    facets: {
        cities: [],
        venues: [],
        prices: [
            {id: '0-999', value: '0 - 999 kr'},
            {id: '1000-1499', value: '1000 - 1499 kr'},
            {id: '1500-1999', value: '1500 - 1999 kr'},
            {id: '2000-2499', value: '2000 - 2499 kr'},
            {id: '2500-2999', value: '2500 - 2999 kr'},
            {id: '3000-3499', value: '3000 - 3499 kr'},
        ],
        other: [
            {
                id: 'senior',
                value: 'Finns seniorbiljetter',
                checked: false,
            },
            {
                id: 'food',
                value: 'Finns matbiljetter',
                checked: false,
            },
            {
                id: 'kids',
                value: 'Finns barnbiljetter',
                checked: false,
            },
            {
                id: 'tour',
                value: 'Evenemang på turné',
                checked: false,
            },
            {
                id: 'hotel-pool',
                value: 'Hotell med pool',
                checked: false,
            },
        ],
    },
    choices: {
        startDate: getInitialURLValue('start-date', (v) => new Date(v), null),
        endDate: getInitialURLValue('end-date', (v) => new Date(v), null),
        cities: ensureLocked(
            'cities',
            getInitialURLValue(
                'cities',
                (v) => v.split(','),
                [],
            ),
        ),
        venues: getInitialURLValue(
            'venues',
            (v) => v.split(','),
            [],
        ),
        prices: getInitialURLValue(
            'prices',
            (v) => [v.split(',').join('-')],
            [],
        ),
        other: getInitialURLValue('other', (v) => v.split(','), []),
        sorting: getInitialURLValue(
            'sort',
            (v) => v,
            application.archive.sorting.default_sorting,
        ),
    },
    totalFilters: null,
    results: [],
    totalResults: null,
    resultPerPage: 20,
};
export default createReducer(initialState, {
    ['CLEAR_ALL_FILTERS']: (state) => {
        return {
            ...state,
            choices: {
                startDate: null,
                endDate: null,
                cities: [],
                venues: [],
                prices: [],
                other: [],
                sorting: application.archive.sorting.default_sorting,
            },
            totalFilters: null,
        };
    },
    ['CLEAR_DATE_FILTER']: (state) => {
        return {
            ...state,
            choices: {
                ...state.choices,
                startDate: null,
                endDate: null,
            },
        };
    },
    ['DATE_CHANGE']: (state, {startDate, endDate}) => {
        return {
            ...state,
            choices: {
                ...state.choices,
                startDate,
                endDate,
            },
        };
    },
    ['TOGGLE_CITY']: (state, {city}) => {
        const isSelected = state.choices.cities.find((id) => id === city.id);
        let values = isSelected ? state.choices.cities.filter((id) => id !==
            city.id) : [...state.choices.cities, city.id];

        return {
            ...state,
            choices: {
                ...state.choices,
                cities: values,
            },
        };
    },
    ['TOGGLE_VENUE']: (state, {venue}) => {
        const isSelected = state.choices.venues.find((id) => id === venue.id);
        let values = isSelected ? state.choices.venues.filter((id) => id !==
            venue.id) : [...state.choices.venues, venue.id];

        return {
            ...state,
            choices: {
                ...state.choices,
                venues: values,
            },
        };
    },
    ['TOGGLE_PRICE']: (state, {price}) => {
        const isSelected = state.choices.prices.find((id) => id === price.id);
        let values = isSelected ? state.choices.prices.filter((id) => id !==
            price.id) : [price.id];

        return {
            ...state,
            choices: {
                ...state.choices,
                prices: values,
            },
        };
    },
    ['TOGGLE_OTHER']: (state, {other}) => {
        const isSelected = state.choices.other.find((id) => id === other.id);
        let values = isSelected ? state.choices.other.filter((id) => id !==
            other.id) : [...state.choices.other, other.id];

        return {
            ...state,
            choices: {
                ...state.choices,
                other: values,
            },
        };
    },
    ['CHANGE_SORTING']: (state, {sorting}) => {
        return {
            ...state,
            choices: {
                ...state.choices,
                sorting,
            },
        };
    },
    ['FETCH_RESULTS']: (state, payload) => {
        const cities = payload.facets.cities.map((city) => {
            return {
                value: city.label,
                id: city.value,
            };
        });

        const venues = payload.facets.venues.map((venue) => {
            return {
                value: venue.label,
                id: venue.value,
            };
        });

        return {
            ...state,
            state: 'success',
            facets: {
                ...state.facets,
                cities,
                venues,
            },
            results: payload.results.map((event) => ({
                ...event,
                premiere: event.premiere ? new Date(event.premiere) : null,
            })),
            totalResults: payload.num_total_results,
            resultPerPage: payload.num_results_per_page,
        };
    },
    ['FETCH_SEARCH_RESULTS']: (state, payload) => {
        const cities = payload.facets.cities.map((city) => {
            return {
                value: city.label,
                id: city.value,
            };
        });

        const venues = payload.facets.venues.map((venue) => {
            return {
                value: venue.label,
                id: venue.value,
            };
        });

        return {
            ...state,
            state: 'success',
            facets: {
                ...state.facets,
                cities,
                venues,
            },
            results: payload.results.map((event) => ({
                ...event,
                premiere: event.premiere ? new Date(event.premiere) : null,
            })),
            totalResults: payload.num_total_results,
            resultPerPage: payload.num_results_per_page,
        };
    },
});
